// extracted by mini-css-extract-plugin
export default {"pl1":"Spinner_pl1__8MD2Z","pl1g":"Spinner_pl1g__DTv9m","pl1rect":"Spinner_pl1rect__Kg3lO","pl1a":"Spinner_pl1a__-cFS6","pl1b":"Spinner_pl1b__EJwz4","pl1c":"Spinner_pl1c__Fms6-"};